'use client';

function isShown(el: HTMLElement): boolean {
  const { display, visibility } = window.getComputedStyle(el);
  if (
    display === 'none' ||
    visibility === 'hidden' ||
    visibility === 'collapse'
  ) {
    return false;
  }
  return el.getClientRects().length > 0;
}

/**
 * True while another dialog is on screen. The cart and mobile nav stay mounted
 * when closed, so they are checked for visibility. `OffersModal` is mounted
 * only while open, but it is `aria-hidden`, so it is matched by its own marker.
 */
export function isBlockingModalOpen(): boolean {
  if (document.querySelector('[data-offers-modal]')) return true;

  const dialogs = document.querySelectorAll<HTMLElement>(
    '[aria-modal="true"], dialog[open]',
  );
  return Array.from(dialogs).some(
    (dialog) =>
      !dialog.closest('[hidden], [inert], [aria-hidden="true"]') &&
      isShown(dialog),
  );
}
